import {
  Descriptions,
  Divider,
  Empty,
  notification,
  Skeleton,
  Tag,
} from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import Modal from "antd/lib/modal/Modal";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { createContext, useContext, useState } from "react";
import ReactQuill from "react-quill";
import renderHTML from "react-render-html";
import _ from "underscore";
import {
  getCurrentUser,
  reactQuiltoolbarOptions,
} from "../../../../Utility/modules/helpers";
import RequestStore from "../store/requeststore";
import NaocDailyProductionStore from "../../store/naocdailyproductionstore";
import TextArea from "antd/lib/input/TextArea";
import { toJS } from "mobx";
import MainStore from "../../../home/store/mainStore";

const requestStoreCtx = createContext(RequestStore);
const mainStorectx = createContext(MainStore);
export const NaocApproveDialog = observer(() => {
  const requestStore = useContext(requestStoreCtx);
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const [overrIdeRemark, setOverrIdeRemark] = useState(false);
  const mainStore = useContext(mainStorectx);
  return (
    <Modal
      centered
      visible={requestStore.showApprovalDialog}
      title={"NAOC Production Sign-off approval"}
      onCancel={() => {
        requestStore.showApprovalDialog = false;
        setOverrIdeRemark(false);
      }}
      width={"60%"}
      okText="Approve"
      okButtonProps={{ loading: requestStore.isSaving }}
      onOk={async () => {
        try {
          naocDailyProductionStore.initFormaData.approver =
            getCurrentUser()?.fullName;
          let { reqView } = await requestStore.saveApprovedProduction(
            [naocDailyProductionStore.initFormaData],
            _.map(requestStore.selAppItems, (x) => toJS(x)),
            requestStore.approverComment,
            getCurrentUser()?.fullName,
            mainStore.assetContextId
          );

          if (requestStore.selAppItems.length === 1) {
            requestStore.myApprovals.delete(reqView.requestApprovalId);
            requestStore.allApprovals.delete(reqView.requestApprovalId);
          } else {
            reqView.forEach((rv) => {
              requestStore.myApprovals.delete(rv.requestApprovalId);
              requestStore.allApprovals.delete(rv.requestApprovalId);
            });
          }

          requestStore.showApprovalDialog = false;
          requestStore.selAppItems = [];

          setOverrIdeRemark(false);
          notification.success({
            message: "SPARS Feedback",
            description: "request approved successfully",
          });
        } catch (error) {
          notification.error({
            message: "SPARS Feedback",
            description: error.response && error.response.text,
          });
        }
      }}
    >
      {naocDailyProductionStore.isLoadingDailyProd ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <Form layout="vertical">
          {requestStore.selAppItems.length > 1 && (
            <>
              <Divider>Approval for:</Divider>
              <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      {requestStore.selAppItems.length}
                    </span>{" "}
                    Producing Day
                    {requestStore.selAppItems.length > 1 ? "s" : ""}
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12">
                    {requestStore.selAppItems.map((d) => (
                      <Tag key={d.productionDate}>
                        {moment(d.productionDate).format("dddd MMM Do YYYY")}
                      </Tag>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}
          {requestStore.selAppItems.length === 1 && (
            <Divider>
              {`NAOC JV Production (Refer) Date: `}
              <span style={{ color: "#1890ff" }}>
                {moment(
                  naocDailyProductionStore.initFormaData.productionDate
                ).format("dddd, MMMM DD,YYYY")}
              </span>
            </Divider>
          )}
          {requestStore.selAppItems.length === 1 && (
            <div>
              {" "}
              {overrIdeRemark === true ? (
                <>
                  <Divider>FIELD ENGINEER REMARKS/NOTES</Divider>
                  
                  <div className="ms-Grid" dir="ltr">
                    {" "}
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm6">
                        <FormItem
                          label="LAND AREA DAILY PRODUCTION REMARKS"
                          labelAlign="left"
                        >
                          <ReactQuill
                            modules={{ toolbar: reactQuiltoolbarOptions }}
                            onChange={(value) => {
                              naocDailyProductionStore.initFormaData.landAreaRemarks =
                                value;
                            }}
                            value={
                              naocDailyProductionStore.initFormaData
                                ?.landAreaRemarks
                            }
                            style={{ minHeight: "300px" }}
                            placeholder="Enter Remarks here"
                          />{" "}
                        </FormItem>
                      </div>
                      <div className="ms-Grid-col ms-sm6">
                        <FormItem
                          label="SWAMP AREA DAILY PRODUCTION REMARKS"
                          labelAlign="left"
                        >
                          <ReactQuill
                            modules={{ toolbar: reactQuiltoolbarOptions }}
                            onChange={(value) => {
                              naocDailyProductionStore.initFormaData.swampAreaRemarks =
                                value;
                            }}
                            style={{ minHeight: "300px" }}
                            placeholder="Enter Remarks here"
                            value={
                              naocDailyProductionStore.initFormaData
                                ?.swampAreaRemarks
                            }
                          />{" "}
                        </FormItem>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Descriptions
                    title="PRODUCTION REMARKS"
                    size={"small"}
                    bordered
                  >
                    <Descriptions.Item label="LAND AREA  PRODUCTION REMARKS">
                      {_.isNull(
                        naocDailyProductionStore.initFormaData.landAreaRemarks
                      ) ? (
                        <>
                          <Empty description="No Remarks" />
                        </>
                      ) : (
                        <>
                          {renderHTML(
                            naocDailyProductionStore.initFormaData
                              .landAreaRemarks
                          )}
                        </>
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="SWAMP AREA  PRODUCTION REMARKS">
                      {_.isNull(
                        naocDailyProductionStore.initFormaData.swampAreaRemarks
                      ) ? (
                        <>
                          <Empty description="No Remarks" />
                        </>
                      ) : (
                        <>
                          {renderHTML(
                            naocDailyProductionStore.initFormaData
                              .swampAreaRemarks
                          )}
                        </>
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                </>
              )}
            </div>
          )}
          {requestStore.selAppItems.length === 1 && (
            <div className="ms-Grid" dir="ltr" style={{ paddingTop: "10px" }}>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6">
                  <Checkbox
                    onChange={(e) => {
                      setOverrIdeRemark(e.target.checked);
                    }}
                  >
                    <span style={{ color: "red" }}>
                      Edit Field Engineer's Remarks
                    </span>
                  </Checkbox>
                </div>
              </div>
            </div>
          )}

          <FormItem label="Approver Remarks" labelAlign="top">
            <TextArea
              label=" "
              rows={5}
              name="description"
              onChange={({ target }) => {
                naocDailyProductionStore.initFormaData.approverComment =
                  target.value;
                requestStore.approverComment = target.value;
              }}
            />
          </FormItem>
        </Form>
      )}
    </Modal>
  );
});

